import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation } from "@tanstack/react-query";

export async function addTags({ tags }) {
  if (!Array.isArray(tags) || tags.length === 0) {
    throw new Error("Tags must be a non-empty array");
  }

  const response = await axios.post(
    getApiRoute("user", "ADD_TAGS"),
    { tags },
    { withCredentials: true }
  );
  return response.data;
}

export const useAddTags = (options = {}) => {
  const mutation = useMutation(addTags, options);
  return mutation;
};
